import { observer } from "mobx-react-lite";
import { CleanUpActions } from "@/components/note/floating-actions/CleanUpActions";
import { MemCommonEditorStore } from "@/components/note/store/MemCommonEditorStore";
import { useRef, useState } from "react";
import { MDSButton, MDSButtonSlotName, MDSButtonVariant, MDSPopover } from "@/mds";
import { MdsIcon, MdsIconKind } from "@/design-system/components/icon";
import styled from "@emotion/styled";

interface CleanUpIndicatorProps {
  editorStore: MemCommonEditorStore;
}
export const CleanUpIndicator = observer(({ editorStore }: CleanUpIndicatorProps) => {
  const [isOpen, setIsOpen] = useState(true);
  const ref = useRef<HTMLButtonElement>(null);
  return (
    <>
      <StyledButton
        ref={ref}
        variant={MDSButtonVariant.EmphasisLight}
        onClick={() => setIsOpen(isOpen => !isOpen)}
      >
        <StyledLeftIcon kind={MdsIconKind.Cleanup} slot={MDSButtonSlotName.LeftIcon} />
        <span>Clean Up</span>
        <StyledRightIcon
          kind={isOpen ? MdsIconKind.AngleDown : MdsIconKind.AngleUp}
          slot={MDSButtonSlotName.RightIcon}
        />
      </StyledButton>
      {editorStore && (
        <MDSPopover
          styling={false}
          triggerRef={ref}
          isOpen={isOpen}
          onOpenChange={setIsOpen}
          isNonModal={true}
        >
          <CleanUpActions editorStore={editorStore} />
        </MDSPopover>
      )}
    </>
  );
});

const StyledButton = styled(MDSButton)`
  height: 32px;
`;

const StyledLeftIcon = styled(MdsIcon)`
  color: ${({ theme }) => theme.colors.icon.emphasis};
`;

const StyledRightIcon = styled(MdsIcon)``;
